module.exports = __webpack_public_path__ + "static/media/p1b.77220b77.ogg";